import {IMapProvider, MapProviderType} from 'app/shared/map/interfaces';
import {LeafletMapProvider} from 'app/shared/map/services/leaflet-map.provider';
import {HereMapProvider} from 'app/shared/map/services/here-map.provider';

/**
 * Map Provider Factory
 * Creates the appropriate map provider based on the provider type
 */
export class MapProviderFactory {
    /**
     * Create a map provider instance
     * @param providerType - The type of provider to create
     * @returns An instance of the requested map provider
     */
    static create(providerType: MapProviderType): IMapProvider {
        console.log('MapProviderFactory.create', providerType);
        switch (providerType) {
            case MapProviderType.HERE_MAPS:
                return new HereMapProvider();
            case MapProviderType.OPEN_STREET_MAP:
                return new LeafletMapProvider();
            default:
                // Default to OpenStreetMap
                console.warn(`Unknown map provider type: ${providerType}. Defaulting to OpenStreetMap.`);
                return new LeafletMapProvider();
        }
    }

    /**
     * Create a map provider from string value (e.g., from backend settings)
     * @param providerString - String representation of provider type
     * @returns An instance of the requested map provider
     */
    static createFromString(providerString: string): IMapProvider {
        const normalizedString = providerString?.toUpperCase().trim();

        // Map string values to enum
        switch (normalizedString) {
            case 'HERE_MAPS':
            case 'HERE':
            case 'HEREMAPS':
                return MapProviderFactory.create(MapProviderType.HERE_MAPS);

            case 'OPEN_STREET_MAP':
            case 'OSM':
            case 'OPENSTREETMAP':
                return MapProviderFactory.create(MapProviderType.OPEN_STREET_MAP);

            default:
                // Default to OpenStreetMap
                console.warn(`Unknown map provider string: ${providerString}. Defaulting to OpenStreetMap.`);
                return MapProviderFactory.create(MapProviderType.OPEN_STREET_MAP);
        }
    }
}
